import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { helper } from 'src/environments/helper';
import { ModLocServiciiService } from './mod-loc-servicii.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import Swal from 'sweetalert2';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { ModulLocatiiServiciiActiveUpdate } from './mod-loc-servicii.interface';
import { AddModLocServiciiComponent } from './add-mod-loc-servicii/add-mod-loc-servicii.component';
import { EditModLocServiciiComponent } from './edit-mod-loc-servicii/edit-mod-loc-servicii.component';

@Component({
    selector: 'app-mod-loc-servicii',
    templateUrl: './mod-loc-servicii.component.html',
    styleUrls: ['./mod-loc-servicii.component.scss']
})
export class ModLocServiciiComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    recordsTotal = 0;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '0' },
        { key: 'Nu', value: '1' },
    ];

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiServiciiActive.getModuleLocatiiServiciiDT;

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private moduleLocatiiServiciiActiveService: ModLocServiciiService,
        public permissionsService: PermissionsService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            pagingType: 'full_numbers',
            responsive: true,
            pageLength: 25,
            searching: false,
            lengthMenu: [10, 25, 50, 100],
            serverSide: true,
            // order: [[4, 'asc']],

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                this.http
                    .post<DataTablesResponse>(
                        this.dtLink, // datatable link, we need this
                        dataTablesParameters // parameters for filtering, send here
                    )
                    .subscribe((resp: any) => {
                        this.isLoading = false;

                        this.recordsTotal = resp.data.recordsTotal;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Modul',
                    data: 'denumire_modul',
                },
                {
                    title: 'Locație',
                    data: 'denumire_locatie',
                },
                {
                    title: 'Serviciu',
                    data: 'denumire_serviciu',
                },
                // {
                //     title: 'Order',
                //     data: 'order',
                //     sortable: true,
                //     render: (data: any, type: any, row: any, met: any) => {
                //         return (
                //             `<div class="order-section-dt"> 
                //                 <button type="button" class="action-btn up-order btn btn-sm btn-primary" ${row.order == 1 ? 'disabled="true"' : ''
                //             } title="-1">
                //                     <img class="btn-img" src="/assets/icons/up-white.svg" alt="down-order"/>
                //                 </button>
                //                 <span class="order">${row.order}</span>
                //                 <button type="button" class="action-btn down-order btn btn-sm btn-primary" ${row.order >= this.recordsTotal ? 'disabled="true"' : ''
                //             } title="+1">
                //                     <img class="btn-img" src="/assets/icons/down-white.svg" alt="up-order"/>
                //                 </button>    
                //             </div>`
                //         );
                //     },
                // },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (data: any, type: any, row: any, met: any) => {
                        return (
                            `
                              <div class="d-flex align-left justify-content-left">
                                                <button type="button" class="action-btn edit ms-1">
                                                    <img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
                                                </button>
                                                <button type="button" class="action-btn delete ms-1">
                                                    <img class="btn-img" src="/assets/icons/delete.svg" alt="delete"/>
                                                </button>
                                                </div>
                                                `
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

                // const orderTD = (row as HTMLElement).querySelector('td:nth-child(5)');
                // const upOrderInSection = orderTD?.querySelector('.up-order') as HTMLElement;
                // const downOrderInSection = orderTD?.querySelector('.down-order') as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.ghiseu-settings.mod-loc-servicii.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.ghiseu-settings.mod-loc-servicii.delete'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteModulLocatiiServicii(id);
                    });
                }

                // if (upOrderInSection) {
                //     if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.mod-loc-servicii.order')) {
                //         upOrderInSection.style.display = 'none';
                //     }
                //     upOrderInSection.addEventListener('click', () => {
                //         const { id } = data;
                //         this.updateStatusOrder(id, -1);
                //     });
                // }

                // if (downOrderInSection) {
                //     if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.mod-loc-servicii.order')) {
                //         downOrderInSection.style.display = 'none';
                //     }
                //     downOrderInSection.addEventListener('click', () => {
                //         const { id } = data;
                //         this.updateStatusOrder(id, 1);
                //     });
                // }

                return row;
            },
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddModLocServiciiComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Modul Locații Servicii Active adăugat cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: ModulLocatiiServiciiActiveUpdate) {
        const dialogRef = this.dialog.open(EditModLocServiciiComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Modul Locații Servicii Active actualizat cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteModulLocatiiServicii(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // we do this because we need to have some control on activity
                this.deleteAction(id);
            }
        });
    }

    deleteAction(id: number) {
        this.isLoading = true;
        this.moduleLocatiiServiciiActiveService.deleteModulLocatiiServicii(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Modul Locații Servicii Active șters cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }

                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleteAction(id);
                    }
                });
            }
        );
    }

    // updateStatusOrder(id: number, index: number) {
    //     this.isLoading = true;

    //     const orderObservable = index === -1 ? this.moduleLocatiiServiciiActiveService.moveUp(id) : this.moduleLocatiiServiciiActiveService.moveDown(id)
    //     orderObservable.subscribe(
    //         () => {
    //             this.rerenderDT();
    //         },
    //         (err: any) => {
    //             let msg;
    //             try {
    //                 // try to catch the message from server
    //                 msg = err.error.errors.message[0];
    //             } catch (error) {
    //                 // controll output message
    //                 msg = helper.dialogConfig.generalMessages.error;
    //             }
    //             this.rerenderDT();
    //             Swal.fire({
    //                 title: helper.dialogConfig.headers.errorAtentie,
    //                 text: msg,
    //                 icon: 'error',
    //                 showCancelButton: true,
    //                 cancelButtonText: helper.dialogConfig.buttonLabels.close,
    //                 reverseButtons: true,
    //                 allowOutsideClick: false,
    //             });
    //         }
    //     );
    // }
}
